<template>
  <div class="carousel-navigation">
    <button
      class="carousel-navigation-button carousel-navigation-prev"
      :class="{ 'carousel-navigation--disabled': !canAdvanceBackward }"
      :aria-disabled="!canAdvanceBackward"
      :disabled="!canAdvanceBackward"
      :aria-label="ariaLabelPrev"
      title="Carousel button navigation prev"
      @click.prevent="triggerPageAdvance('backward')"
    >
      <svg class="icon">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-back"></use>
      </svg>
    </button>
    <button
      class="carousel-navigation-button carousel-navigation-next"
      :class="{ 'carousel-navigation--disabled': !canAdvanceForward }"
      :aria-disabled="!canAdvanceForward"
      :disabled="!canAdvanceForward"
      :aria-label="ariaLabelNext"
      title="Carousel button navigation next"
      @click.prevent="triggerPageAdvance('forward')"
    >
      <svg class="icon">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-icon"></use>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'navigation',
  props: {
    ariaLabelPrev: {
      type: String,
      default: '',
    },
    ariaLabelNext: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      parentContainer: this.$parent,
    };
  },
  computed: {
    canAdvanceForward() {
      return this.parentContainer.canAdvanceForward || false;
    },
    canAdvanceBackward() {
      return this.parentContainer.canAdvanceBackward || false;
    },
  },
  methods: {
    triggerPageAdvance(direction) {
      this.$parent.advancePage(direction, 'navigation');
    },
  },
};
</script>
